import { groupCapabilityTemplates } from './groupHelpers.js';
export const simpleGroupTemplateIds = [
    'publicGroup',
    'localGroup',
    'privateGroup',
    'announcementGroup',
    'lockedGroup',
];
const TEMPLATE_RELATIONSHIPS = [
    'none',
    'local',
    'member',
    'moderator',
    'admin',
    'owner',
];
const normalizeBucket = (bucket) => ({
    add: [...(bucket?.add ?? [])].sort(),
    remove: [...(bucket?.remove ?? [])].sort(),
});
export const normalizeGroupCapabilitiesForMatch = (capabilities) => {
    const normalized = {};
    for (const relationship of TEMPLATE_RELATIONSHIPS) {
        const bucket = capabilities?.[relationship];
        if (!bucket?.add?.length && !bucket?.remove?.length)
            continue;
        normalized[relationship] = normalizeBucket(bucket);
    }
    return normalized;
};
export const groupCapabilitiesMatchTemplate = (capabilities, templateCapabilities) => JSON.stringify(normalizeGroupCapabilitiesForMatch(capabilities)) ===
    JSON.stringify(normalizeGroupCapabilitiesForMatch(templateCapabilities));
export const getSimpleGroupTemplateCapabilities = (templateId) => {
    const template = groupCapabilityTemplates[templateId];
    return structuredClone(template.capabilities);
};
export const matchSimpleGroupTemplate = (capabilities) => {
    for (const templateId of simpleGroupTemplateIds) {
        if (groupCapabilitiesMatchTemplate(capabilities, groupCapabilityTemplates[templateId].capabilities)) {
            return templateId;
        }
    }
    return 'custom';
};
export const applySimpleGroupTemplate = (templateId) => getSimpleGroupTemplateCapabilities(templateId);
export const defaultSimpleGroupTemplate = (publicContent) => (publicContent ? 'publicGroup' : 'localGroup');
export const simpleGroupTemplateOptions = (publicContent) => simpleGroupTemplateIds.filter((id) => publicContent || id !== 'publicGroup');
